<template>
  <div class="mt-10 pb-20 w-11/12 lg:w-3/4 mx-auto">
    <div class="flex justify-between items-center mt-32 mx-auto">
      <h1 class="text-lg md:text-2xl py-3 pl-2 uppercase">
        {{ $t('tiers.tiers') }}
      </h1>
      <router-link class="font-bold rounded-lg mx-2 transform hover:scale-105 text-xs
      font-sans-serif bg-beige-academy-500 py-3 px-4 text-white lg:text-base
      duration-400 shadow-lg border md:border-4 border-gray-200"
      :to="'/teachers/'+$route.params.slug+'/calendar'">
        {{ $t('tiers.book') }}
      </router-link>
    </div>

    <div class="flex flex-col mt-10 w-full mx-auto">
      <tier-row-for-student v-for="tier in tiers" :key="tier.id" :tier="tier"
      :editable="false" @clicked="open = tier.id" :open="open" />
    </div>
  </div>
</template>

<script>
import { getTeacherTiers } from '@/services/TeacherService';
import TierRowForStudent from './TierRowForStudent.vue';

export default {
  components: {
    TierRowForStudent,
  },

  data() {
    return {
      tiers: [],

      open: null,
    };
  },

  created() {
    this.getTiers();
  },

  methods: {
    getTiers() {
      getTeacherTiers(this.$route.params.slug).then(({ data }) => {
        this.tiers = [];
        this.tiers = data;
      });
    },
  },
};
</script>
